import {
    IItem,
    ICookieCart,
    IOrderCart,
    ICartsObject,
    IItemSimple,
    IAddressBlock,
    ISalesOrderRequest,
    IItemLine,
} from "../interfaces/cart.interfaces";
import { ICookieCheckoutAddresses } from "../interfaces/checkout.interfaces";

import Cookies from "js-cookie";

import { OverlaysService } from "./overlays.service";
import { EOverlay } from "../EOverlay";
import { USEREMAIL, SITEURL } from "@libTs/cms.globals";
import axios from "axios";

export class CartService {
    private get EXPIRES(): Date {
        const now = new Date();
        now.setDate(now.getDate() + 14); // now + 14 days
        return now;
    }
    private readonly COOKIENAME = "cart" + USEREMAIL;
    private readonly CHECKOUTCOOKIENAME = "checkout" + USEREMAIL;
    private readonly COOKIESETTINGS = { path: "/", expires: this.EXPIRES };

    private readonly THP_ITEMNAME = "Third-party";
    private readonly THP_ITEMCODE = "thp";

    public lastAddedItem?: IItem = undefined;

    public hasCartInitError: boolean | undefined = undefined;

    public cartObj: ICartsObject = {
        customerEmail: "",
        customerNumber: "",
        isOrderForOtherUser: false,
        carts: [
            {
                orderReference: "",
                orderName: "",
                currency: "",
                items: [],
                count: 0,
                totalPrice: 0,
            },
        ],
        count: 0,
        totalPrice: 0,
    };

    public isLoading = false;

    public openCart = false;

    private overlaysSvc: OverlaysService;

    public isLoggedIn = false;

    constructor(overlaysSvc: OverlaysService, isLoggedIn: boolean = false) {
        this.overlaysSvc = overlaysSvc;
        this.isLoggedIn = isLoggedIn;

        this.initializeCartFromCookie();
        this.initializeEventListener();
    }

    public isUserLoggedIn(): boolean {
        return this.isLoggedIn;
    }

    public initializeCartFromCookie(): void {
        const cartObj: ICartsObject = this.getCartCookie() as ICartsObject;

        if (
            cartObj &&
            typeof cartObj === "object" &&
            cartObj.carts.length > 0
        ) {
            this.isLoading = true;

            // console.log("initializeCartFromCookie", cartObj);

            if (!cartObj.customerEmail) {
                cartObj.customerEmail = "";
                cartObj.customerNumber = "";
            }
            if (cartObj.isOrderForOtherUser !== true) {
                cartObj.isOrderForOtherUser = false;
            }
            const carts: Array<IOrderCart> = [];
            for (const cart of cartObj.carts) {
                if (cart.items.length > 0) {
                    carts.push(cart);
                }
            }
            cartObj.carts = carts;
            cartObj.count = 0;
            cartObj.totalPrice = 0;

            axios
                .post<Array<IOrderCart>>(
                    SITEURL + "actions/sapShop/products/get-cart-products",
                    cartObj.carts,
                    {
                        responseType: "json",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                        },
                    },
                )
                .then(
                    // success
                    (response) => {
                        cartObj.carts = response.data;

                        if (cartObj.carts) {
                            for (const cart of cartObj.carts) {
                                for (let i = 0; i < cart.items.length; ++i) {
                                    cart.items[i].q = cart.items[i].quantity;

                                    // THP (only in default cart)
                                    if (
                                        cart.orderReference.length <= 0 &&
                                        cart.items[i].ItemCode ===
                                            this.THP_ITEMCODE
                                    ) {
                                        cart.items[i].ItemName =
                                            this.THP_ITEMNAME;

                                        const event = new CustomEvent(
                                            "updateThpInCartStatus",
                                            { detail: true },
                                        );
                                        document.dispatchEvent(event);
                                    }
                                    // END THP

                                    // check if item has price set, else remove from cart
                                    if (
                                        cart.items[i].ItemCode !==
                                            this.THP_ITEMCODE &&
                                        (cart.items[i].Preis === null ||
                                            typeof cart.items[i].Preis ===
                                                "undefined" ||
                                            cart.items[i].Preis <= 0)
                                    ) {
                                        console.warn(
                                            `Product with ItemCode '${cart.items[i].ItemCode}' has no price set. Removing from cart.`,
                                        );
                                        cart.items.splice(i, 1);
                                        --i;
                                    }
                                }
                            }

                            this.hasCartInitError = false;
                        }
                    },

                    // error
                    (response: any) => {
                        this.hasCartInitError = true;

                        console.error(response);
                        // reset carts
                        cartObj.carts = [
                            {
                                orderReference: "",
                                orderName: "",
                                currency: "",
                                items: [],
                                count: 0,
                                totalPrice: 0,
                            },
                        ];
                    },
                )
                .then(() => {
                    this.cartObj = cartObj;
                    this.updateTotalPrice();
                })
                .finally(() => {
                    this.isLoading = false;

                    // create event for cart loaded
                    const event = new Event("cartLoaded");
                    document.dispatchEvent(event);

                    // console.log(this.hasCartInitError);
                    // console.log(this.isLoading);
                    // console.log("Cart initialized from cookie.", this.cartObj);
                });
        } else {
            this.delCheckoutAddrCookie();
        }

        // THP
        // this.$rootScope.$broadcast( 'thpLoading' );
        axios
            .get(SITEURL + "actions/sapShop/thp/get-value", {
                responseType: "json",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            })
            .then(
                // success
                (response: any) => {
                    let data = response.data;

                    if (
                        typeof data === "undefined" ||
                        !data ||
                        data.status !== 200
                    ) {
                        if (!data) {
                            data = { status: 500, value: "" };
                        }
                        data.value = "";
                        // console.info( 'THP value not found in DB. Using empty string.' );
                        // console.info( response );
                    }

                    const event = new CustomEvent("thpValueUpdate", {
                        detail: {
                            value: data.value,
                            addToCart: false,
                            append: false,
                        },
                    });
                    document.dispatchEvent(event);
                },
            )
            .finally(() => {
                const event = new CustomEvent("thpLoaded");
                document.dispatchEvent(event);
            });
        // END THP
    }

    // update total price
    public updateTotalPrice(): number {
        let totalPrice = 0;
        let itemsCount = 0;

        // reset customerEmail & isOrderForOtherCustomer if there are no carts
        // or the only cart is the default one (non CSV)
        if (
            !this.cartObj.carts ||
            this.cartObj.carts.length === 0 ||
            (this.cartObj.carts.length === 1 &&
                this.cartObj.carts[0] ===
                    this.getDefaultCart(this.cartObj.carts))
        ) {
            this.cartObj.customerEmail = "";
            this.cartObj.customerNumber = "";
            this.cartObj.isOrderForOtherUser = false;
            this.delCheckoutAddrCookie();
        }

        const cookieCart: ICookieCart = {
            customerEmail:
                this.cartObj.customerEmail.length > 0
                    ? this.cartObj.customerEmail
                    : "",
            customerNumber:
                typeof this.cartObj.customerNumber === "string" &&
                this.cartObj.customerNumber.length > 0
                    ? this.cartObj.customerNumber
                    : "",
            isOrderForOtherUser: this.cartObj.isOrderForOtherUser,
            carts: [],
            count: 0,
            totalPrice: 0,
        };

        const carts: Array<IOrderCart> = [];
        if (this.cartObj.carts) {
            for (let ci = 0; ci < this.cartObj.carts.length; ++ci) {
                const cart = this.cartObj.carts[ci];

                // this removes all empty carts except for the main cart
                if (
                    !cart.orderReference || // must be main cart
                    cart.orderReference.length <= 0 || // true for main cart
                    cart.items.length > 0 // any cart that has items
                ) {
                    carts.push(cart);
                } else {
                    continue;
                }

                cookieCart.carts.push({
                    orderReference: cart.orderReference,
                    orderName: cart.orderName,
                    currency: cart.currency,
                    items: [],
                });

                cart.totalPrice = 0;
                cart.count = 0;

                for (let i = 0; i < cart.items.length; ++i) {
                    const item: IItem = cart.items[i];

                    if (
                        typeof item.quantity === "undefined" ||
                        item.quantity < 0
                    ) {
                        // this.removeFromCart(item.ItemCode, item.quantity);
                        continue;
                    }

                    if (item.ItemCode !== this.THP_ITEMCODE) {
                        cart.totalPrice +=
                            item.quantity * this.getItemSinglePrice(item);
                    }
                    cart.count += item.quantity;

                    const cookieCartItem: IItemSimple = {
                        ItemCode: item.ItemCode,
                        quantity: item.quantity,
                        isMonolot: item.isMonolot,
                    };
                    // update Name reference per item (only if new item has this property set)
                    if (typeof item.Name === "string" && item.Name.length) {
                        cookieCartItem.Name = item.Name;
                    }
                    cookieCart.carts[cookieCart.carts.length - 1].items.push(
                        cookieCartItem,
                    );
                }

                totalPrice += cart.totalPrice;
                itemsCount += cart.count;
            }
        }
        this.cartObj.carts = carts;

        this.cartObj.totalPrice = totalPrice;
        cookieCart.totalPrice = totalPrice;

        this.cartObj.count = itemsCount;
        cookieCart.count = itemsCount;

        // write cookie
        this.setCartCookie(cookieCart);

        return totalPrice;
    }

    public updateSinglePrice(e: any, item: IItem): void {
        let q = parseInt(item.q as string, 10);
        if (!q || q < 0) {
            q = 0;
        }
        item.quantity = q;
        this.updateTotalPrice();
    }

    public areCartsEmpty(): boolean {
        const isEmpty =
            this.cartObj.carts.filter(
                (c) => Array.isArray(c.items) && c.items.length > 0,
            ).length === 0;
        return isEmpty;
    }

    /**
     * Adds an item to the specified cart
     *
     * @param {IItem} item The item to add
     * @param {number} quantity Amount of item to add
     * @param {IOrderCart} cart Which cart (leave empty of use `undefined` for default cart)
     * @param {boolean} [displayOverlay] Whether to display the item added overlay
     * @param {boolean} [updatePrice] Whether to recalculate the cart total price
     * @returns {(IItem | null)} Returns the item or null, if a step failed
     * @memberof CartService
     */
    public addItemToCart(
        item: IItem,
        quantity: number,
        cart?: IOrderCart,
        displayOverlay?: boolean,
        updatePrice?: boolean,
    ): IItem | null {
        this.lastAddedItem = undefined;

        if (typeof cart !== "object" || cart === null) {
            cart = this.getDefaultCart(this.cartObj.carts);
        }

        displayOverlay =
            typeof displayOverlay === "undefined" ? true : displayOverlay;

        if (quantity < 1) {
            console.warn("Error: Cannot add item with quantity lower than 1.");
            return null;
        }

        let foundItemInCart: IItem | undefined;

        for (let i = 0; i < cart.items.length; ++i) {
            if (cart.items[i].ItemCode === item.ItemCode) {
                foundItemInCart = cart.items[i];

                // update quantity
                if (item.ItemCode === this.THP_ITEMCODE) {
                    // THP
                    cart.items[i].quantity = 1;
                    cart.items[i].q = 1;

                    const event = new CustomEvent("updateThpInCartStatus", {
                        detail: true,
                    });
                    document.dispatchEvent(event);
                } else {
                    cart.items[i].quantity += quantity;
                    cart.items[i].q =
                        parseInt((cart.items[i].q as number).toString(), 10) +
                        quantity;
                    // update Name reference per item (only if new item has this property set)
                    if (typeof item.Name === "string" && item.Name.length) {
                        cart.items[i].Name = item.Name;
                    }
                }
                break;
            }
        }

        if (foundItemInCart) {
            this.lastAddedItem = foundItemInCart;
        } else {
            this.lastAddedItem = item;
            item.quantity = quantity;
            item.q = quantity;
            cart.items.push(item);
        }

        if (updatePrice !== false) {
            this.updateTotalPrice();
        }

        // notify user
        if (displayOverlay) {
            // console.log("item added to cart", item);

            // this.overlaysSvc.showOverlay(EOverlay.itemAddedToCart);
            this.openCart = true;
        }

        return item;
    }

    // update quantity
    public updateQuantity(
        item: IItem,
        quantity: number,
        cart: IOrderCart,
    ): void {
        if (typeof cart === "undefined") {
            cart = this.getDefaultCart(this.cartObj.carts);
        }

        for (let i = 0; i < cart.items.length; ++i) {
            const currentItem: IItem = cart.items[i];
            if (currentItem.ItemCode === item.ItemCode) {
                const qty = quantity - currentItem.quantity;

                if (qty > 0) {
                    this.addItemToCart(item, qty, cart);
                } else if (qty < 0) {
                    // this.removeFromCart(item.ItemCode, -qty);
                }
                return;
            }
        }

        if (quantity > 0) {
            this.addItemToCart(item, quantity, cart);
        }
    }

    // remove from cart
    public removeFromCart(
        code: string,
        quantity: number,
        cart: IOrderCart,
    ): boolean {
        if (typeof cart === "undefined") {
            cart = this.getDefaultCart(this.cartObj.carts);
        }

        if (quantity < 0) {
            console.warn(
                "Error: Cannot remove item with quantity smaller than 1.",
            );
            return false;
        }

        for (let i = 0; i < cart.items.length; ++i) {
            const item: IItem = cart.items[i];
            if (item.ItemCode === code) {
                if (item.quantity - quantity > 0) {
                    cart.items[i].quantity -= quantity;
                } else if (cart.items.length > 1) {
                    cart.items.splice(i, 1);
                } else {
                    cart.items = [];
                }

                // THP
                if (item.ItemCode === this.THP_ITEMCODE) {
                    const event = new CustomEvent("updateThpInCartStatus", {
                        detail: false,
                    });
                    document.dispatchEvent(event);
                }
                // END THP

                this.updateTotalPrice();
                return true;
            }
        }
        return false;
    }

    // update Monolot status for item in cart
    public updateMonolotStatus(item?: IItem): void {
        if (item && "isMonolot" in item) {
            for (const cart of this.cartObj.carts) {
                const foundItem = cart.items.find(
                    (it) => it.ItemCode === item.ItemCode,
                );
                if (foundItem) {
                    // console.log("ha! found ya!", foundItem);
                    foundItem.isMonolot = item.isMonolot;
                    break;
                }
            }

            // save to cookie
            this.updateTotalPrice();
        }
    }

    public getMonolotCheckoutText(): string {
        let monolotItems: Array<IItem> = [];
        for (const cart of this.cartObj.carts) {
            const foundItems = cart.items.filter((it) => it.isMonolot);
            if (foundItems.length) {
                monolotItems = monolotItems.concat(...foundItems);
            }
        }

        if (monolotItems.length) {
            return (
                "---Monolot---\n" +
                monolotItems.map((it) => `[x] ${it.ItemCode}`).join("\n") +
                "\n---End Monolot---\n\n"
            );
        }
        return "";
    }

    // clear cart and cookie
    public clearCarts(removeCookie?: boolean): void {
        this.cartObj = {
            customerEmail: "",
            customerNumber: "",
            isOrderForOtherUser: false,
            carts: [
                {
                    orderReference: "",
                    orderName: "",
                    currency: "",
                    items: [],
                    count: 0,
                    totalPrice: 0,
                },
            ],
            count: 0,
            totalPrice: 0,
        };

        // THP
        const event = new CustomEvent("updateThpInCartStatus", {
            detail: false,
        });
        document.dispatchEvent(event);
        // END THP

        if (typeof removeCookie === "undefined" || removeCookie === true) {
            this.$cookies.remove(this.COOKIENAME, { path: "/" });
        }

        console.info("Cart has been emptied.");
    }

    // clear single cart
    public clearCart(cart: IOrderCart, updateCookie?: boolean): void {
        if (!cart) {
            return;
        }

        const items = cart.items;
        cart.items = [];

        for (const item of items) {
            // THP
            if (item.ItemCode === this.THP_ITEMCODE) {
                const event = new CustomEvent("updateThpInCartStatus", {
                    detail: false,
                });
                document.dispatchEvent(event);
                break;
            }
            // END THP
        }

        if (
            this.cartObj.carts.length < 1 ||
            (this.cartObj.carts.length === 1 &&
                this.cartObj.carts[0].orderReference.length <= 0)
        ) {
            this.cartObj.customerEmail = "";
            this.cartObj.customerNumber = "";
            this.cartObj.isOrderForOtherUser = false;
        }

        if (updateCookie === true) {
            this.updateTotalPrice();
        }
    }

    /**
     * Gets the special price of a given item.
     *
     * @param {IItem} item
     * @returns {number} The special price to use.
     */
    public getItemSinglePrice(item: IItem): number {
        if (item.ItemCode === this.THP_ITEMCODE) {
            return 0;
        }
        return item.Preis;
    }

    /**
     * Gets the special price of a given item.
     *
     * @param {IItem} item
     * @returns {number} The special price to use.
     */
    public getItemPriceTyp(item: IItem): number {
        return item.PriceTyp;
    }

    /**
     * Check if a given item is using a special price for the customer.
     *
     * @param {IItem} item
     * @returns {boolean} True, when either Preis_Prio1 to Prio3 is not null, false for only Preis_Prio4 not null (default price)
     */
    public hasItemSpecialPrice(item: IItem): boolean {
        return (
            item.SpecialPrice === true || String(item.SpecialPrice) === "true"
        );
    }

    // get request JSON
    public getOrderRequestObject(
        billingAddress: IAddressBlock,
        shipToCode: string,
        shipAddress: IAddressBlock,
        comments: string,
        orderRefNr?: string,
    ): Array<ISalesOrderRequest> {
        // DEBUG
        // console.log("getOrderRequestObject", {
        //     billingAddress,
        //     shipToCode,
        //     shipAddress,
        //     comments,
        // });

        const orderRequests: Array<ISalesOrderRequest> = [];

        for (const cart of this.cartObj.carts) {
            const itemLines: IItemLine[] = [];
            let cartShippingAddress = {} as IAddressBlock;
            cartShippingAddress = Object.assign(
                cartShippingAddress,
                shipAddress,
            );

            for (let i = 0; i < cart.items.length; ++i) {
                if (cart.items[i].quantity === 0) {
                    cart.items.splice(i, 1);
                }

                const item: IItem = cart.items[i];

                const itemLine: IItemLine = {
                    ItemCode: item.ItemCode,
                    Quantity: item.quantity,
                    PromoPrice: item.Preis,
                };
                // add "Name" (only used in CSV as an reference per item)
                if (typeof item.Name === "string" && item.Name.length) {
                    itemLine.Name = item.Name;
                }
                itemLines.push(itemLine);
            }

            let orderRefNumber = "";
            if (cart.orderReference && cart.orderReference.length > 0) {
                orderRefNumber = cart.orderReference;
            } else if (orderRefNr && orderRefNr.length > 0) {
                orderRefNumber = orderRefNr;
            }

            const orderRequest: ISalesOrderRequest = {
                Email:
                    this.cartObj.customerEmail.length > 0
                        ? this.cartObj.customerEmail
                        : "", // will be set by plugin service
                CsvOrderName: cart.orderName ? cart.orderName : "",
                OrderRefNr: orderRefNumber,
                OrderName: cart.orderName,
                ItemLines: itemLines,
                Comments: comments || "",
            };

            if (
                typeof cartShippingAddress !== "undefined" &&
                (!shipToCode || shipToCode.length === 0 || shipToCode === "CSV")
            ) {
                // DEBUG
                // console.log("getOrderRequestObject if(true)", [
                //     typeof cartShippingAddress,
                //     !shipToCode,
                //     shipToCode.length === 0,
                //     shipToCode === "CSV",
                // ]);

                delete cartShippingAddress.AddressId;
                if (!cartShippingAddress.Country) {
                    cartShippingAddress.Country = "CH";
                }

                if (shipToCode === "CSV") {
                    cartShippingAddress.Address2 =
                        cartShippingAddress.AddressName2; // + '\n' + cartShippingAddress.AddressName3;
                    cartShippingAddress.Address3 =
                        cartShippingAddress.AddressName3; // + ( cart.orderName.length > 0 ? ', ' + cart.orderName : '' );
                } else if (
                    cartShippingAddress.Address2obj &&
                    cartShippingAddress.Address3obj
                ) {
                    cartShippingAddress.Address2 = `${cartShippingAddress.Address2obj.Company}
${cartShippingAddress.Address2obj.Department}`;
                    cartShippingAddress.Address3 = `${cartShippingAddress.Address3obj.Title}
${cartShippingAddress.Address3obj.FirstName} ${cartShippingAddress.Address3obj.LastName}`;
                    if (
                        cartShippingAddress.Address2obj &&
                        cartShippingAddress.Address2obj.County
                    ) {
                        cartShippingAddress.County =
                            cartShippingAddress.Address2obj.County;
                    }

                    delete cartShippingAddress.Address2obj;
                    delete cartShippingAddress.Address3obj;
                } else {
                    cartShippingAddress.Address2 = null;
                    cartShippingAddress.Address3 = null;
                }

                const ADRESS_MAX_LENGTH = 50;

                if (
                    cartShippingAddress.Address2?.length &&
                    cartShippingAddress.Address2?.length > ADRESS_MAX_LENGTH
                ) {
                    cartShippingAddress.Address2 =
                        cartShippingAddress.Address2.substring(
                            0,
                            ADRESS_MAX_LENGTH - 3,
                        ) + "...";
                }
                if (
                    cartShippingAddress.Address3?.length &&
                    cartShippingAddress.Address3?.length > ADRESS_MAX_LENGTH
                ) {
                    cartShippingAddress.Address3 =
                        cartShippingAddress.Address3.substring(
                            0,
                            ADRESS_MAX_LENGTH - 3,
                        ) + "...";
                }

                orderRequest.ShipAddress = cartShippingAddress;
            } else {
                // console.log("getOrderRequestObject if(false)", [
                //     orderRequest.ShipToCode,
                //     shipToCode,
                // ]);
                orderRequest.ShipToCode = shipToCode;
            }

            // billing address
            orderRequest.PayToCode = billingAddress.AddressId;

            orderRequests.push(orderRequest);
        }
        // console.log("getOrderRequestObject orderRequests", orderRequests);
        return orderRequests;
    }

    /**
     * Creates an OCI items obj for "/oci/basket/order"
     *
     * IMPORTANT: On default cart is used. No multi cart.
     */
    public getOrderRequestObjectOci(): { [itemCode: string]: IItemSimple } {
        // get default cart
        const cart = this.cartObj.carts[0];

        const orderObj: { [itemCode: string]: IItemSimple } = {};

        for (let i = 0; i < cart.items.length; ++i) {
            // remove 0 quantity items
            if (cart.items[i].quantity === 0) {
                cart.items.splice(i, 1);
            }

            const item: IItem = cart.items[i];

            const orderItem: IItemSimple = {
                ItemCode: item.ItemCode,
                quantity: item.quantity,
            };

            // add "Name" (only used in CSV as an reference per item)
            if (typeof item.Name === "string" && item.Name.length) {
                orderItem.Name = item.Name;
            }

            orderObj[item.ItemCode] = orderItem;
        }

        return orderObj;
    }

    /**
     * Finds and returns the default cart in a list of carts.
     * If no default cart is found, it creates a default cart
     * and adds it to the beginning of the list.
     *
     * @private
     * @param {Array<IOrderCart>} scopeCarts A list of carts to search
     * @returns {IOrderCart} The default cart object
     * @memberof CartService
     */
    public getDefaultCart(scopeCarts: Array<IOrderCart>): IOrderCart {
        for (const cart of scopeCarts) {
            if (cart.orderReference.length <= 0) {
                return cart;
            }
        }

        // create default cart and add to scopeCarts at the start
        const cart = {
            orderReference: "",
            orderName: "",
            currency: "",
            items: [],
            count: 0,
            totalPrice: 0,
        };
        scopeCarts.unshift(cart);

        return cart;
    }

    public getAllRelatedProducts(): Array<any> {
        let allRelatedProducts: Array<any> = [];
        // console.log(this.cartObj.carts);

        this.cartObj.carts[0]?.items.forEach((item) => {
            if (item.relatedProducts) {
                item.relatedProducts.forEach((relatedProducts) => {
                    if (!allRelatedProducts.includes(relatedProducts)) {
                        allRelatedProducts.push(relatedProducts);
                    }
                });
            }
        });

        return allRelatedProducts;
    }

    public thpAddToCart(
        item: any,
        quantity: number,
        displayOverlay: boolean,
    ): void {
        if (item) {
            this.addItemToCart(
                item,
                quantity,
                this.getDefaultCart(this.cartObj.carts),
                displayOverlay,
            );

            this.overlaysSvc.hideOverlays();
            this.openCart = true;
        } else {
            console.warn(
                "Error while receiving 'addToCartEvent': item argument is null.",
            );
        }
    }

    private getCartCookie(): any {
        let cookie = Cookies.get(this.COOKIENAME);

        if (cookie) {
            return JSON.parse(cookie);
        } else {
            return null;
        }
    }
    private setCartCookie(carts: ICookieCart): void {
        if (!this.hasCartInitError) {
            Cookies.set(
                this.COOKIENAME,
                JSON.stringify(carts),
                this.COOKIESETTINGS,
            );
        }
    }
    public setCheckoutAddrCookie(
        checkoutAddresses: ICookieCheckoutAddresses,
    ): void {
        Cookies.set(
            this.CHECKOUTCOOKIENAME,
            JSON.stringify(checkoutAddresses),
            this.COOKIESETTINGS,
        );
    }
    private delCheckoutAddrCookie(): void {
        if (!this.hasCartInitError) {
            Cookies.remove(this.CHECKOUTCOOKIENAME);
        }
    }

    private initializeEventListener(): void {
        document.addEventListener("addItemsToCartsEvent", (e: any) => {
            let carts = e.detail.carts;
            let customerEmail = e.detail.customerEmail;
            let customerNumber = e.detail.customerNumber;
            let isOrderForOtherUser = e.detail.isOrderForOtherUser;

            let callback = e.detail.itemsAddedToCartCallback;

            // console.log("addItemsToCartsEvent", [
            //     carts,
            //     customerEmail,
            //     customerNumber,
            //     isOrderForOtherUser,
            // ]);
            if (carts && carts.length > 0) {
                // set customer number
                this.cartObj.customerEmail = customerEmail;
                this.cartObj.customerNumber = customerNumber;
                this.cartObj.isOrderForOtherUser = isOrderForOtherUser;

                for (const cart of carts) {
                    let existingCart = null;
                    // search for existing cart
                    for (const c of this.cartObj.carts) {
                        if (c.orderReference === cart.orderReference) {
                            existingCart = c;
                        }
                    }
                    if (existingCart === null) {
                        // create new cart
                        existingCart = {
                            orderReference: cart.orderReference,
                            orderName: cart.orderName,
                            currency: cart.currency,
                            items: [],
                            count: 0,
                            totalPrice: 0,
                        };
                        // add newly created cart to the carts
                        this.cartObj.carts.push(existingCart);
                    }

                    for (const item of cart.items) {
                        this.addItemToCart(
                            item,
                            item.quantity,
                            existingCart,
                            false,
                            false,
                        );
                    }
                }

                // manually trigger total price update
                this.openCart = true;
                this.updateTotalPrice();
                if (typeof callback === "function") {
                    callback(true);
                }
            } else {
                console.warn(
                    "Error while receiving 'addItemsToCartsEvent': Carts argument is null or empty.",
                );
                if (typeof callback === "function") {
                    callback(false);
                }
            }
        });

        document.addEventListener(
            "setCheckoutShippingBillingAddress",
            (e: any) => {
                let shippingAddress = e.detail.shippingAddress;
                let billingAddress = e.detail.billingAddress;

                // console.log("setCheckoutShippingBillingAddress", [
                //     shippingAddress,
                //     billingAddress,
                // ]);

                if (!shippingAddress) {
                    return;
                }

                // IMPORTANT (pj, 2018-02-19):
                // Currently the only way to send a billing address to the SAP API is by 'AddressId'.
                // Therefore we ignore the billing address sent from the CSV
                this.setCheckoutAddrCookie({
                    shipping: shippingAddress,
                    billing: {} as IAddressBlock, // billingAddress
                });
            },
        );
    }
}
